import React from 'react';
import IconTitleButton from "components/buttons/IconTitleButton";
import {pickWhiteGrayGradient} from "components/utils/UiUtils";
import {Divider} from "@material-ui/core";
import messages from 'res/messages/farsi'
import IconTitleValue from "components/textValue/IconTitleValue";
import {IsLP_MP_SP, IsNotSM} from "my-styles/media/media";

import ICDeliver from "res/images/deliver.png";
import ICMail from "res/images/message.png";
import ICPhone from "res/images/phone.png";
import ICGuarantee from "res/images/guarantee.png";
import ICSupport from "res/images/support.png";
import ICPay from "res/images/pay.png";
import ICInstagram from "res/images/instagram_colored.png";
import ICMapCompany from "res/images/mapCompany.jpg";

export default function Footer() {

    function getLargeView() {
        return <div className="paddingLeftRightLarge">
            <div className="marginTopMedium">
                <div className="xLargeTextBold">
                    {messages.aboutUs}
                </div>
                <div className="horizontalScreen">
                    <div className="fullWidth">
                        <div className="largeText justify">
                            {messages.sarfeDescription}
                        </div>
                        <div className="xLargeTextBold marginTopMedium">
                            {messages.connectWithUs}
                        </div>
                        <div className="horizontalScreen">
                            <IconTitleValue
                                icon={<img src={ICPhone} alt={"صرفه مارکت"} className="xSmallIcon"/>}
                                title={messages.phone}
                                value={messages.suppurtNumber}/>
                            <IconTitleValue
                                icon={<img src={ICMail} alt={"صرفه مارکت"} className="xSmallIcon marginRightSmall"/>}
                                title={messages.email}
                                value={messages.sarfeMarketEmail}/>
                            <IconTitleValue
                                className="clickable"
                                icon={<img src={ICInstagram} alt={"صرفه مارکت"} className="xSmallIcon"/>}
                                title={messages.instagram}
                                value={messages.sarfeMarketInstagram}
                                onClick={() => {
                                    window.open(messages.instagramLink, "_blank")
                                }}/>
                        </div>
                    </div>
                    <div className="marginRightSmall">
                        <img src={ICMapCompany} alt={"صرفه مارکت"} className="mapLogo"/>
                    </div>
                    <div className="marginRightLarge">
                        <div style={{cursor: 'pointer'}} className="enamadLogo">
                            <a referrerPolicy='origin' target='_blank'
                               href='https://trustseal.enamad.ir/?id=179587&Code=g3DycxyaiDPX4fbc9224'>
                                {/*<img*/}
                                {/*    referrerPolicy='origin'*/}
                                {/*    src='https://trustseal.enamad.ir/logo.aspx?id=179587&Code=g3DycxyaiDPX4fbc9224'*/}
                                {/*    alt=''*/}
                                {/*    style={{cursor: 'pointer', width: "100%", height: "100%"}}*/}
                                {/*    Code='g3DycxyaiDPX4fbc9224'/>*/}
                                <img
                                    referrerPolicy='origin'
                                    src='https://trustseal.enamad.ir/logo.aspx?id=179587&Code=g3DycxyaiDPX4fbc9224'
                                    alt=''
                                    style={{cursor: 'pointer', width: "100%", height: "100%"}}
                                    />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    function getSmallView() {
        return <div className="paddingSmall">
            <div className="marginTopMedium">
                <div className="xLargeTextBold">
                    {messages.aboutUs}
                </div>
                <div className="largeText justify marginTopSmall">
                    {messages.sarfeDescription}
                </div>
                <div className="xLargeTextBold marginTopMedium">
                    {messages.connectWithUs}
                </div>
                <div className="horizontalScreen marginTopMedium">
                    <div className="fullWidth">
                        <IconTitleValue
                            icon={<img src={ICPhone} alt={"صرفه مارکت"} className="xxSmallIcon"/>}
                            title={messages.phone}
                            value={messages.suppurtNumber}/>
                        <IconTitleValue
                            icon={<img src={ICMail} alt={"صرفه مارکت"} className="xxSmallIcon"/>}
                            title={messages.email}
                            value={messages.sarfeMarketEmail}/>
                        <IconTitleValue
                            icon={<img src={ICInstagram} alt={"صرفه مارکت"} className="xxSmallIcon"/>}
                            title={messages.instagram}
                            value={messages.sarfeMarketInstagram}
                            onValueClick={() => {
                                window.open(messages.instagramLink, "_blank")
                            }}/>
                    </div>
                    {IsNotSM() &&
                        <div className="marginRightSmall">
                            <img src={ICMapCompany} alt={"صرفه مارکت"} className="mapLogo"/>
                        </div>
                    }
                    <div className="marginLeftRightSmall">
                        <div style={{cursor: 'pointer'}} className="enamadLogo">
                            <a referrerPolicy='origin' target='_blank'
                               href='https://trustseal.enamad.ir/?id=179587&Code=g3DycxyaiDPX4fbc9224'>
                                <img
                                    referrerPolicy='origin'
                                    src='https://trustseal.enamad.ir/logo.aspx?id=179587&Code=g3DycxyaiDPX4fbc9224'
                                    alt=''
                                    style={{cursor: 'pointer', width: "100%", height: "100%"}}
                                    Code='g3DycxyaiDPX4fbc9224'/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    function getFeatureSection() {
        return <center>
            <table className="inPc75InTabletMobilePhablet100">
                <tbody>
                <tr className="center">
                    <td className="oneFromFour">
                        <IconTitleButton
                            textcolor="var(--gray_4)"
                            fontSize="smallTextBold"
                            isvertical={"true"}
                            icon={<img className="mediumIcon" src={ICGuarantee} alt=""/>}
                            title={messages.guaranteeProduct}/>
                    </td>
                    <td className="oneFromFour">
                        <IconTitleButton
                            textcolor="var(--gray_4)"
                            fontSize="smallTextBold"
                            isvertical={"true"}
                            icon={<img className="mediumIcon" src={ICSupport} alt=""/>}
                            title={messages.support}/>
                    </td>
                    <td className="oneFromFour">
                        <IconTitleButton
                            textcolor="var(--gray_4)"
                            fontSize="smallTextBold"
                            isvertical={"true"}
                            icon={<img className="mediumIcon" src={ICPay} alt=""/>}
                            title={messages.payInPlace}/>
                    </td>
                    <td className="oneFromFour">
                        <IconTitleButton
                            textcolor="var(--gray_4)"
                            fontSize="smallTextBold"
                            isvertical={"true"}
                            icon={<img className="mediumIcon" src={ICDeliver} alt=""/>}
                            title={messages.deliverInPlace}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </center>
    }

    function getCopyrightSection() {
        return <div className="screen marginTopMedium" style={{padding: "0.2em", backgroundColor: "var(--gray_8)"}}>
            <label className="smallTextBold">
                {messages.sarfeCopyright}
            </label>
        </div>
    }

    return (<div className="screenNotCentered" style={{marginTop: "1em", backgroundImage: pickWhiteGrayGradient()}}>
        <Divider/>
        {getFeatureSection()}
        <Divider/>
        {IsLP_MP_SP() ? getLargeView() : getSmallView()}
        {getCopyrightSection()}
    </div>)

}